"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getItemsByDomainExtraReducers = void 0;
const tslib_1 = require("tslib");
const services_1 = tslib_1.__importDefault(require("../../../services"));
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const __model__1 = tslib_1.__importDefault(require("./__model__"));
const getIncludesParams_1 = require("../../../shared/getIncludesParams");
const getItemsByDomain = toolkitRaw.createAsyncThunk('store/fetch_items', async (data, { rejectWithValue }) => {
    try {
        const response = await services_1.default.get(`/api/stores/${data.store_domain || 'acme'}/items`, {
            params: {
                includes: (0, getIncludesParams_1.getDefaultIncludesParams)('stores_items'),
            },
        });
        const itemsImpl = new __model__1.default(response);
        itemsImpl.findByQuery(data === null || data === void 0 ? void 0 : data.query);
        return itemsImpl.data;
    }
    catch (eventError) {
        return rejectWithValue(eventError);
    }
});
const getItemsByDomainExtraReducers = (builder) => {
    builder.addCase(getItemsByDomain.pending, (state) => {
        state.items.loading = true;
    });
    builder.addCase(getItemsByDomain.fulfilled, (state, action) => {
        state.items.loading = false;
        state.items.data = action.payload;
    });
    builder.addCase(getItemsByDomain.rejected, (state) => {
        state.items.loading = false;
    });
};
exports.getItemsByDomainExtraReducers = getItemsByDomainExtraReducers;
exports.default = getItemsByDomain;
//# sourceMappingURL=index.js.map